import Quill from 'quill';

const IconPicker = Quill.import('ui/icon-picker');

class MtIconPicker extends IconPicker {
  constructor(select, label) {
    super(select, label);
    this.container.classList.add('ql-bar');
  }
}

export default MtIconPicker;
